module.exports = __webpack_public_path__ + "img/logo_navbar.c2b2d64f.png";